import { ContentfulClientApi, createClient, EntryCollection, LocaleCollection } from "contentful";
import { ContentModelName } from "./types";

export default class ContentfulClientService {
  client: ContentfulClientApi = {} as ContentfulClientApi;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public authorized: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public currentSpace: any;

  constructor(space: string, accessToken: string, preview: boolean) {
    this.initClient(space, accessToken, preview);
  }

  private initClient = (space: string, accessToken: string, preview: boolean) => {
    let environment: string | undefined;
    try {
      const override = localStorage.getItem("contentful_environment");
      if (override !== null) {
        environment = override;
      }
    } catch (e) {
      e;
    }
    if (!space || !accessToken) {
      return;
    }
    if (environment === undefined) {
      this.client = createClient({
        space: space,
        accessToken: accessToken,
        host: preview ? "preview.contentful.com" : "cdn.contentful.com",
      });
    } else {
      this.client = createClient({
        space: space,
        accessToken: accessToken,
        environment: environment,
        host: preview ? "preview.contentful.com" : "cdn.contentful.com",
      });
    }
  };

  public getEntriesForMultipleTypes(contentTypes: string[], locale?: string) {
    return this.client.getEntries({ "sys.contentType.sys.id[in]": contentTypes.join(","), locale: locale, include: 6 });
  }
  public getEntries(contentType: string, locale?: string, ids?: string[], limit?: number) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let q: any = { content_type: contentType, locale: locale, include: 6, limit: limit || 100 };
    if (ids) {
      q = { ...q, "fields.id[in]": ids.join(",") };
    }
    return this.client.getEntries(q);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getInfoPage(id: string, locale?: string): Promise<EntryCollection<any>> {
    return this.client.getEntries({ "fields.id": id, content_type: ContentModelName.INFOPAGE, locale: locale, include: 6 });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getPromoPage(id: string, locale?: string): Promise<EntryCollection<any>> {
    return this.client.getEntries({ "fields.id": id, content_type: ContentModelName.PROMOPAGE, locale: locale, include: 6 });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getGameListSection(): Promise<EntryCollection<any>> {
    return this.client.getEntries({ content_type: ContentModelName.GAMELISTSECTION });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getGameListSectionById(id: string): Promise<EntryCollection<any>> {
    return this.client.getEntries({ "fields.id": id, content_type: ContentModelName.GAMELISTSECTION });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getUserLevelsPage(locale?: string): Promise<EntryCollection<any>> {
    return this.client.getEntries({ content_type: ContentModelName.USERLEVELS, locale: locale });
  }

  public getLocales(): Promise<LocaleCollection> {
    return this.client.getLocales();
  }

  public getContentType(id: string) {
    return this.client.getContentType(id);
  }

  public getClient = () => {
    return this.authorized && this.client;
  };

  public getCurrentSpaceName = (): string => {
    const currentSpaceName = this.currentSpace && this.currentSpace.name ? this.currentSpace.name : "";
    return currentSpaceName;
  };

  public resetClient = () => {
    window.sessionStorage.clear();
    this.authorized = false;
  };
}

// export { initClient, getClient, resetClient, getCurrentSpaceName }
